(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('AgenceSetupController', AgenceSetupController);

    AgenceSetupController.$inject = ['$scope', "leafletMapEvents",'$stateParams','$state', '$timeout', '$sce', '$window', 'entity', 'templateEntity', 'Agence', 'AgenceTemplate', 'WaterNetwork',
        'ChannelConf', 'Principal', 'AssistantPanelService', '$translate'];

    function AgenceSetupController ($scope, leafletMapEvents, $stateParams, $state, $timeout, $sce, $window, entity, templateEntity, Agence, AgenceTemplate, WaterNetwork, ChannelConf,
        Principal, AssistantPanelService, $translate) {
        var TEMPLATE_PREVIEW_DELAY_MS = 300;
        var globalCommunicationPreviewPromise;
        var clientPortalMessagePreviewPromise;
        var documentPreviewVersion = 0;
        var vm = this;
        vm.agence = entity;
        vm.agenceTemplate = buildEmptyAgenceTemplate();
        vm.waterNetworks = WaterNetwork.query({ offset: 0,size: 1000});
        vm.channelConfs = ChannelConf.query({ page: 0, size: 1000, sort: 'nom,asc' });
        vm.onlinePaymentTypes = [{code:'MTN_USSD_V1', label:'MTN USSD'},{code:'MPESA_PAYBILL_V1', label:'M-Pesa Paybill'}];
        vm.isEmailChannelConf = isEmailChannelConf;
        vm.isSmsChannelConf = isSmsChannelConf;
        vm.showClientPortalTemplateHelp = false;
        vm.canUseAssistant = false;
        vm.geometryMapRefreshToken = 0;
        vm.globalCommunicationPreview = buildEmptyTemplatePreview();
        vm.clientPortalMessagePreview = buildEmptyTemplatePreview();
        vm.previewInvoiceTemplate = previewInvoicePdfTemplate;
        vm.previewReceiptTemplate = previewReceiptTemplate;
        vm.previewBillingNoticePdfTemplate = previewBillingNoticePdfTemplate;
        vm.previewBillingNoticeTemplate = previewBillingNoticeTemplate;
        vm.clientPortalTemplateVariableDetails = [
            { name: '${contractRef}', description: 'Référence du contrat.' },
            { name: '${contractName}', description: 'Nom de la personne du contrat.' },
            { name: '${contractAddress}', description: 'Adresse du contrat.' },
            { name: '${amountBilled}', description: 'Montant de la dernière facturation.' },
            { name: '${totalToBePaid}', description: 'Solde total restant à payer.' },
            { name: '${servicesToBePaid}', description: 'Détail texte des services restant à payer.' },
            { name: '${taxesToBePaid}', description: 'Détail texte des taxes restant à payer.' },
            { name: '${servicesToBePaidHtml}', description: 'Détail HTML des services restant à payer.' },
            { name: '${taxesToBePaidHtml}', description: 'Détail HTML des taxes restant à payer.' },
            { name: '${dateNow}', description: 'Date du jour.' },
            { name: '${url}', description: 'Lien de réinitialisation du mot de passe portail client.' },
            { name: '${tokenTmp}', description: 'Code temporaire de réinitialisation envoyé par SMS.' },
            { name: '${clientPortalAreaName}', description: 'Nom de la zone affiché dans le portail client.' },
            { name: '${messageContent}', description: 'Contenu principal injecté dans un habillage global.' },
            { name: '${messageContentText}', description: 'Version texte brut du contenu principal.' },
            { name: '${areaName}', description: 'Nom de la zone.' },
            { name: '${urlLogo}', description: 'URL du logo de la zone.' },
            { name: '${contactAddress}', description: 'Adresse de contact affichée au client.' },
            { name: '${contactEmail}', description: 'Email de contact affiché au client.' },
            { name: '${contactTel}', description: 'Téléphone de contact affiché au client.' },
            { name: '${contactWebsite}', description: 'Site web de contact affiché au client.' }
        ];
        vm.clientPortalTemplateVariables = vm.clientPortalTemplateVariableDetails.map(function(variable) {
            return variable.name;
        });
        vm.toggleClientPortalTemplateHelp = function () {
            vm.showClientPortalTemplateHelp = !vm.showClientPortalTemplateHelp;
        };
        vm.openClientPortalAssistantChat = openClientPortalAssistantChat;
        vm.onGeometryTabSelect = function() {
            vm.geometryMapRefreshToken = vm.geometryMapRefreshToken + 1;
        };

        vm.timezones = Agence.getTimezones();
        initializeAgenceTemplate(templateEntity);
        vm.updateCoord = function(){
          	
        	//On remet à 0 en cas d'erreur sur le champs.
        	if(! vm.agence.lat ){
        		vm.agence.lat = 0;
        	}
        	if(! vm.agence.lon){
        		vm.agence.lon = 0;
        	}

        	if( vm.agence.geographicCoord){
        		vm.geometry = vm.agence.geographicCoord;
        	}
        	
	        angular.extend($scope, {
	            defaults: {
	                scrollWheelZoom: false
	            },
//	            events: {
//	                map: {
//	                    enable: [ 'drag', 'click'],
//	                    logic: 'emit'
//	                }
//	            },
	            markers: {
	                Area: {
	                    lat: vm.agence.lat,
	                    lng: vm.agence.lon,
//	                    message: "This is Madrid. But you can drag me to another position",
	                    focus: true,
	                    draggable: true
	                }
	            }
	        })
        }
        
        vm.load = function(id) {
            Agence.get({id : id}, function(result) {
                vm.agence = result;

            	vm.updateCoord ();
               
                
            });
        };
        
        if(entity && entity.$promise){
            entity.$promise.then(function(value) {
            	vm.updateCoord ();
                Agence.getClientPortalConf({idArea : vm.agence.id}, function(result) {
                	vm.agence.clientPortalConf =  result;
                    scheduleGlobalCommunicationPreview();
                    scheduleClientPortalMessagePreview();
                });

                Agence.getOnlinePaymentConf({idArea : vm.agence.id}, function(result) {
                	vm.agence.areaConfOnlinePayment =  result;
                },  function(error) {
                	//on ne fait rien en cas de 404
                });
            });	
        }else{
        	vm.updateCoord();
        }

        Principal.identity().then(function(account) {
            if (account) {
                vm.canUseAssistant = (account.modules || []).indexOf('AI_ASSISTANT') !== -1
                    && (account.authorities.indexOf('ROLE_AI_ASSISTANT') !== -1
                    || account.authorities.indexOf('ROLE_ADMIN') !== -1
                    || account.authorities.indexOf('ROLE_SUPER_ADMIN') !== -1);
            }
        });
        registerClientPortalPreviewWatchers();
        scheduleGlobalCommunicationPreview();
        scheduleClientPortalMessagePreview();

        $scope.$on("leafletDirectiveMarker.dragend", function(event, args){
            if (!args || args.modelName !== 'contrat') {
                return;
            }
            vm.agence.lat = args.model.lat;
            vm.agence.lon = args.model.lng;
        });


        vm.save = function () {
        	Agence.update(vm.agence, onSaveSuccess, onSaveError);
        };

        vm.saveTemplate = function () {
            vm.templateHtmlError = '';
            vm.isSavingTemplateForm = true;
            AgenceTemplate.update({idArea: vm.agence.id}, vm.agenceTemplate, onSaveSuccessTemplate, onSaveError);
        };

        vm.saveClientPortalConf = function () {
            vm.templateHtmlError = '';
            vm.agence.clientPortalConf.agence = {id: vm.agence.id};
        	Agence.saveClientPortalConf(vm.agence.clientPortalConf, onSaveSuccessClientPortalConf, onSaveError);
        };

        vm.saveOnlinePaymentConf = function () {
        	vm.agence.areaConfOnlinePayment.agence  = {id:vm.agence.id};
        	Agence.saveOnlinePaymentConf (vm.agence.areaConfOnlinePayment, onSaveSuccessOnlinePaymentConf, onSaveError);
        };
        var onSaveSuccessOnlinePaymentConf = function (result) {
            $scope.$emit('wamasysApp:onlinePaymentConfUpdate', result);
        	vm.agence.areaConfOnlinePayment =  result;
        };
        
        
        vm.saveGeometryConf = function () {
        	var data = {agence: vm.agence ,geometry: vm.geometry  };
        	Agence.saveGeometryConf (data, onSaveSuccessGeometryConf , onSaveError);
        };
        var onSaveSuccessGeometryConf = function (result) {
            $scope.$emit('wamasysApp:geometryConfUpdate', result);
        };

        var onSaveSuccessTemplate = function (result) {
            $scope.$emit('wamasysApp:agenceTemplateUpdate', result);
            vm.agenceTemplate = angular.extend(buildEmptyAgenceTemplate(), result || {});
            vm.isSavingTemplateForm = false;
            scheduleGlobalCommunicationPreview();
            scheduleClientPortalMessagePreview();
        };

        
        var onSaveSuccessClientPortalConf = function (result) {
            $scope.$emit('wamasysApp:clientPortalConfUpdate', result);
        	vm.agence.clientPortalConf =  result;
            scheduleGlobalCommunicationPreview();
            scheduleClientPortalMessagePreview();
        };
        
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:agenceUpdate', result);
         //   $state.go('area-setup', {id:vm.agence.id}, { reload: true });
        };

        var onSaveError = function (response) {
            if (response && response.data && response.data.message === 'error.unsafeTemplateHtml') {
                vm.templateHtmlError = $translate.instant('error.unsafeTemplateHtml');
            }
            vm.isSaving = false;
            vm.isSavingTemplateForm = false;
            vm.isSavingAreaConfForm = false;
            vm.isSavingOnlinePaymentConfForm = false;
            vm.isSavingEditGeometryForm = false;
        };
        
        vm.clear = function() {
            $state.go($state.current.name, {id:vm.agence.id}, { reload: true });
        };

        function isEmailChannelConf(channelConf) {
            return channelConf && (channelConf.channel === 'EMAIL_SMTP' || channelConf.channel === 'EMAIL_SENDBLUE');
        }

        function isSmsChannelConf(channelConf) {
            return channelConf && (
                channelConf.channel === 'SMS_ORACOM'
                || channelConf.channel === 'SMS_PHILSMS'
                || channelConf.channel === 'SMS_BULKSMSBD'
                || channelConf.channel === 'SMS_AWS'
            );
        }

        function initializeAgenceTemplate(resolvedTemplate) {
            if (!resolvedTemplate) {
                return;
            }

            vm.agenceTemplate = angular.extend(buildEmptyAgenceTemplate(), resolvedTemplate);
            scheduleGlobalCommunicationPreview();
            scheduleClientPortalMessagePreview();
        }

        function openClientPortalAssistantChat() {
            if (!vm.canUseAssistant || !vm.agence || !vm.agence.clientPortalConf) {
                return;
            }

            AssistantPanelService.open({
                contextType: 'CLIENT_PORTAL_CONF',
                entityId: vm.agence.clientPortalConf.id || vm.agence.id,
                title: $translate.instant('global.assistant.templateTitle'),
                subtitle: vm.agence.clientPortalConf.areaName || vm.agence.nom || 'Espace client',
                promptPlaceholder: $translate.instant('global.assistant.templatePromptPlaceholder'),
                supportsActionProposal: false,
                supportsDataScopes: false,
                adapter: {
                    chat: function(payload, success, error) {
                        Agence.chatClientPortalAssistant(buildClientPortalAssistantRequest(payload), success, error);
                    },
                    getUsage: function(success, error) {
                        Agence.getClientPortalAssistantUsage(success, error);
                    },
                    submitFeedback: function(payload, success, error) {
                        Agence.submitClientPortalAssistantFeedback(payload, success, error);
                    },
                    applyAssistantResponse: function(result) {
                        if (!result || !result.suggestedFieldValues) {
                            return;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template) && result.suggestedFieldValues.template !== null) {
                            vm.agence.clientPortalConf.templateTxt = result.suggestedFieldValues.template;
                            vm.agence.clientPortalConf.templateSms = result.suggestedFieldValues.template;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template_html) && result.suggestedFieldValues.template_html !== null) {
                            vm.agence.clientPortalConf.templateHtml = result.suggestedFieldValues.template_html;
                        }
                        if (angular.isDefined(result.suggestedFieldValues.template_subject) && result.suggestedFieldValues.template_subject !== null) {
                            vm.agence.clientPortalConf.templateSubject = result.suggestedFieldValues.template_subject;
                        }
                        AssistantPanelService.invalidateConversationContext();
                        $scope.$evalAsync();
                    },
                    buildContextSignatureFragment: function() {
                        return [
                            vm.agence.id || '',
                            hashString(vm.agenceTemplate.communicationGlobalSmsTemplate || ''),
                            hashString(vm.agenceTemplate.communicationGlobalEmailTemplateHtml || ''),
                            hashString(vm.agence.clientPortalConf.templateSms || ''),
                            hashString(vm.agence.clientPortalConf.templateTxt || ''),
                            hashString(vm.agence.clientPortalConf.templateHtml || ''),
                            hashString(vm.agence.clientPortalConf.templateSubject || '')
                        ].join('|');
                    }
                }
            });
        }

        function buildClientPortalAssistantRequest(payload) {
            return {
                assistantRequest: payload,
                communicationAutomationConf: {
                    id: vm.agence.clientPortalConf.id,
                    type: 'CLIENT_PORTAL_CONF',
                    template: vm.agence.clientPortalConf.templateTxt || vm.agence.clientPortalConf.templateSms,
                    templateHtml: vm.agence.clientPortalConf.templateHtml,
                    templateSubject: vm.agence.clientPortalConf.templateSubject
                },
                availableVariables: angular.copy(vm.clientPortalTemplateVariables),
                selectedChannel: vm.agence.clientPortalConf.emailChannelConf ? vm.agence.clientPortalConf.emailChannelConf.channel
                    : (vm.agence.clientPortalConf.smsChannelConf ? vm.agence.clientPortalConf.smsChannelConf.channel : 'EMAIL_SMTP'),
                contextType: 'CLIENT_PORTAL_CONF',
                contextEntityId: vm.agence.clientPortalConf.id || vm.agence.id,
                contextLabel: vm.agence.clientPortalConf.areaName || vm.agence.nom,
                contextMetadata: {
                    areaName: vm.agence.clientPortalConf.areaName,
                    pathUrl: vm.agence.clientPortalConf.pathUrl,
                    contactEmail: vm.agence.clientPortalConf.contactEmail,
                    contactTel: vm.agence.clientPortalConf.contactTel,
                    availableVariableDetails: angular.copy(vm.clientPortalTemplateVariableDetails),
                    communicationGlobalSmsTemplate: vm.agenceTemplate.communicationGlobalSmsTemplate,
                    communicationGlobalEmailTemplateHtml: vm.agenceTemplate.communicationGlobalEmailTemplateHtml,
                    showInvoice: vm.agence.clientPortalConf.showInvoice,
                    showReceipt: vm.agence.clientPortalConf.showReceipt
                }
            };
        }

        function registerClientPortalPreviewWatchers() {
            $scope.$watchGroup([
                function() { return vm.agenceTemplate && vm.agenceTemplate.communicationGlobalSmsTemplate; },
                function() { return vm.agenceTemplate && vm.agenceTemplate.communicationGlobalEmailTemplateHtml; }
            ], function() {
                scheduleGlobalCommunicationPreview();
            });

            $scope.$watchGroup([
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.areaName; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.urlLogo; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.contactAddress; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.contactEmail; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.contactTel; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.contactWebsite; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.templateSms; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.templateTxt; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.templateHtml; },
                function() { return vm.agence.clientPortalConf && vm.agence.clientPortalConf.templateSubject; },
                function() { return vm.agenceTemplate && vm.agenceTemplate.communicationGlobalSmsTemplate; },
                function() { return vm.agenceTemplate && vm.agenceTemplate.communicationGlobalEmailTemplateHtml; }
            ], function() {
                scheduleClientPortalMessagePreview();
            });

            $scope.$on('$destroy', function() {
                if (globalCommunicationPreviewPromise) {
                    $timeout.cancel(globalCommunicationPreviewPromise);
                }
                if (clientPortalMessagePreviewPromise) {
                    $timeout.cancel(clientPortalMessagePreviewPromise);
                }
            });
        }

        function scheduleGlobalCommunicationPreview() {
            if (globalCommunicationPreviewPromise) {
                $timeout.cancel(globalCommunicationPreviewPromise);
            }
            globalCommunicationPreviewPromise = $timeout(refreshGlobalCommunicationPreview, TEMPLATE_PREVIEW_DELAY_MS);
        }

        function scheduleClientPortalMessagePreview() {
            if (clientPortalMessagePreviewPromise) {
                $timeout.cancel(clientPortalMessagePreviewPromise);
            }
            clientPortalMessagePreviewPromise = $timeout(refreshClientPortalMessagePreview, TEMPLATE_PREVIEW_DELAY_MS);
        }

        function refreshGlobalCommunicationPreview() {
            if (!vm.agenceTemplate) {
                vm.globalCommunicationPreview = buildEmptyTemplatePreview();
                return;
            }

            var variables = buildGlobalCommunicationPreviewVariables();
            var sampleMessage = buildGlobalCommunicationPreviewContent();
            var finalSms = applySmsGlobalTemplatePreview(sampleMessage.sms, variables);
            var finalHtml = applyEmailGlobalTemplatePreview(sampleMessage.text, sampleMessage.html, variables);

            vm.globalCommunicationPreview = {
                hasContent: !!(finalSms || finalHtml),
                sms: finalSms || '',
                subject: '',
                text: '',
                html: finalHtml || '',
                trustedHtml: $sce.trustAsHtml('')
            };
            validatePreviewHtml('globalCommunicationPreview', finalHtml);
        }

        function refreshClientPortalMessagePreview() {
            if (!vm.agence || !vm.agence.clientPortalConf) {
                vm.clientPortalMessagePreview = buildEmptyTemplatePreview();
                return;
            }

            var variables = buildClientPortalPreviewVariables();
            var previewText = processTemplate(vm.agence.clientPortalConf.templateTxt, variables);
            var previewHtmlContent = processTemplate(vm.agence.clientPortalConf.templateHtml, variables);
            var previewSmsContent = processTemplate(vm.agence.clientPortalConf.templateSms, variables);
            var previewSubject = processTemplate(vm.agence.clientPortalConf.templateSubject, variables);
            var finalSms = applySmsGlobalTemplatePreview(previewSmsContent, variables);
            var finalHtml = applyEmailGlobalTemplatePreview(previewText, previewHtmlContent, variables);

            vm.clientPortalMessagePreview = {
                hasContent: !!(finalSms || previewSubject || previewText || finalHtml),
                sms: finalSms || '',
                subject: previewSubject || '',
                text: previewText || '',
                html: finalHtml || '',
                trustedHtml: $sce.trustAsHtml('')
            };
            validatePreviewHtml('clientPortalMessagePreview', finalHtml);
        }

        // Ne jamais insérer le HTML saisi : seul le résultat contrôlé par OWASP est rendu.
        function validatePreviewHtml(previewName, html) {
            var preview = vm[previewName];
            if (!html) {
                return;
            }
            AgenceTemplate.validateHtml({html: html}, function(result) {
                // Une réponse ancienne ne doit pas remplacer l'aperçu d'une saisie plus récente.
                if (vm[previewName] === preview) {
                    preview.trustedHtml = $sce.trustAsHtml(result.html || '');
                }
            }, function(response) {
                if (vm[previewName] === preview) {
                    preview.error = $translate.instant(response && response.data
                        && response.data.message === 'error.unsafeTemplateHtml'
                        ? 'error.unsafeTemplateHtml' : 'error.templateHtmlValidationUnavailable');
                }
            });
        }

        function buildClientPortalPreviewVariables() {
            return {
                contractRef: 'CTR-2026-0042',
                contractName: 'Jean Dupont',
                contractAddress: '12 rue de la Paix, 75002 Paris',
                amountBilled: '1200.00 EUR',
                totalToBePaid: '960.00 EUR',
                servicesToBePaid: 'Water sales : 800.00 EUR\nInstallment : 160.00 EUR',
                taxesToBePaid: 'VAT : 40.00 EUR',
                servicesToBePaidHtml: '<tr><th scope="row">Water sales</th><td>800.00 EUR</td></tr><tr><th scope="row">Installment</th><td>160.00 EUR</td></tr>',
                taxesToBePaidHtml: '<tr><th scope="row">VAT</th><td>40.00 EUR</td></tr>',
                dateNow: new Date().toLocaleDateString(),
                url: 'https://my.wamasys.example/area/demo/reset-password',
                tokenTmp: '123456',
                clientPortalAreaName: (vm.agence.clientPortalConf.areaName || vm.agence.nom || 'Espace client'),
                areaName: (vm.agence.clientPortalConf.areaName || vm.agence.nom || 'Espace client'),
                urlLogo: vm.agence.clientPortalConf.urlLogo || '',
                contactAddress: vm.agence.clientPortalConf.contactAddress || '',
                contactEmail: vm.agence.clientPortalConf.contactEmail || '',
                contactTel: vm.agence.clientPortalConf.contactTel || '',
                contactWebsite: vm.agence.clientPortalConf.contactWebsite || ''
            };
        }

        function buildGlobalCommunicationPreviewVariables() {
            return {
                contractRef: 'CTR-2026-0042',
                contractName: 'Jean Dupont',
                contractAddress: '12 rue de la Paix, 75002 Paris',
                amountBilled: '1200.00 EUR',
                totalToBePaid: '960.00 EUR',
                servicesToBePaid: 'Water sales : 800.00 EUR\nInstallment : 160.00 EUR',
                taxesToBePaid: 'VAT : 40.00 EUR',
                servicesToBePaidHtml: '<tr><th scope="row">Water sales</th><td>800.00 EUR</td></tr><tr><th scope="row">Installment</th><td>160.00 EUR</td></tr>',
                taxesToBePaidHtml: '<tr><th scope="row">VAT</th><td>40.00 EUR</td></tr>',
                dateNow: new Date().toLocaleDateString(),
                url: 'https://my.wamasys.example/area/demo/reset-password',
                tokenTmp: '123456',
                clientPortalAreaName: 'Espace client démo',
                areaName: vm.agence.nom || 'Zone de démonstration',
                urlLogo: 'https://assets.wamasys.example/logo-demo.png',
                contactAddress: 'Avenue de la République, centre-ville',
                contactEmail: 'contact@example.com',
                contactTel: '+33 1 23 45 67 89',
                contactWebsite: 'https://www.example.com'
            };
        }

        function buildGlobalCommunicationPreviewContent() {
            return {
                sms: 'Bonjour Jean Dupont, votre facture d\'eau est disponible. Merci de régulariser votre solde avant le 10/05/2026.',
                text: 'Bonjour Jean Dupont,\nVotre facture d\'eau est disponible dans votre espace client.\nMerci de régulariser votre solde avant le 10/05/2026.',
                html: '<div class="message-content-text"><p>Bonjour Jean Dupont,</p><p>Votre facture d\'eau est disponible dans votre espace client.</p><p>Merci de régulariser votre solde avant le <strong>10/05/2026</strong>.</p></div>'
            };
        }

        function buildEmptyTemplatePreview() {
            return {
                hasContent: false,
                sms: '',
                subject: '',
                text: '',
                html: '',
                trustedHtml: $sce.trustAsHtml('')
            };
        }

        function processTemplate(template, variables) {
            if (!template) {
                return '';
            }
            return template.replace(/\$\{([^}]+)}|\$(\w+)/g, function(match, expression, alias) {
                var key = expression || alias;
                return angular.isDefined(variables[key]) && variables[key] !== null ? variables[key] : '';
            });
        }

        function applySmsGlobalTemplatePreview(messageContent, variables) {
            var globalTemplate = vm.agenceTemplate && vm.agenceTemplate.communicationGlobalSmsTemplate;
            if (!globalTemplate) {
                return messageContent || '';
            }
            return processTemplate(ensureMessagePlaceholder(globalTemplate, '\n'), angular.extend({}, variables || buildClientPortalPreviewVariables(), {
                messageContent: messageContent || '',
                messageContentText: messageContent || ''
            }));
        }

        function applyEmailGlobalTemplatePreview(messageText, messageHtml, variables) {
            var globalTemplate = vm.agenceTemplate && vm.agenceTemplate.communicationGlobalEmailTemplateHtml;
            var htmlContent = messageHtml || textToHtml(messageText || '');
            if (!globalTemplate) {
                return htmlContent;
            }
            return processTemplate(ensureMessagePlaceholder(globalTemplate, '<br/>'), angular.extend({}, variables || buildClientPortalPreviewVariables(), {
                messageContent: htmlContent || '',
                messageContentText: messageText || ''
            }));
        }

        function ensureMessagePlaceholder(template, separator) {
            if (!template || containsMessagePlaceholder(template)) {
                return template || '';
            }
            var lowerTemplate = template.toLowerCase();
            var bodyIndex = lowerTemplate.lastIndexOf('</body>');
            if (bodyIndex >= 0) {
                return template.substring(0, bodyIndex) + separator + '${messageContent}' + template.substring(bodyIndex);
            }
            return '${messageContent}' + separator + template;
        }

        function containsMessagePlaceholder(template) {
            return template && (template.indexOf('${messageContent}') >= 0 || template.indexOf('$messageContent') >= 0);
        }

        function textToHtml(value) {
            return '<div class="message-content-text">' + escapeHtml(value || '').replace(/\n/g, '<br/>') + '</div>';
        }

        function previewReceiptTemplate() {
            previewDocumentTemplate('Aperçu reçu', 'receiptTemplate');
        }

        function previewDocumentTemplate(title, fieldName) {
            var template = vm.agenceTemplate[fieldName] || '';
            var version = ++documentPreviewVersion;
            // Ouvrir une fenêtre vide pendant le clic évite le blocage des fenêtres après l'appel réseau.
            // Aucun contenu saisi n'y est inséré avant les deux validations serveur.
            var previewWindow = $window.open('', '_blank');
            vm.templateHtmlError = '';
            if (!previewWindow) {
                return;
            }
            function isCurrent() {
                return version === documentPreviewVersion && template === (vm.agenceTemplate[fieldName] || '');
            }
            AgenceTemplate.validateDocumentTemplate({template: template}, function(result) {
                if (!isCurrent() || previewWindow.closed) {
                    previewWindow.close();
                    return;
                }
                openPrintablePreview(title,
                    '<div class="document-preview document-preview--ticket">'
                        + renderReceiptTemplate(result.template, buildSampleReceiptPreviewData()) + '</div>',
                    previewWindow, isCurrent);
            }, function(response) {
                failDocumentPreview(response, previewWindow, isCurrent);
            });
        }

        function previewInvoiceTemplate() {
            openPrintablePreview(
                'Aperçu facture',
                renderInvoicePreview(buildSampleInvoicePreviewData())
            );
        }

        function previewInvoicePdfTemplate() {
            Agence.previewInvoice(buildAgenceTemplatePreviewPayload(), function(result) {
                openGeneratedPdf(result);
            });
        }

        function previewBillingNoticePdfTemplate() {
            Agence.previewPaymentRecoveryNotice(buildAgenceTemplatePreviewPayload(), function(result) {
                openGeneratedPdf(result);
            });
        }

        function previewBillingNoticeTemplate() {
            previewDocumentTemplate('Aperçu ordre de recouvrement', 'billingNoticeTemplate');
        }

        function openGeneratedPdf(result) {
            var url;
            var link;
            if (!result || !result.response) {
                return;
            }
            url = URL.createObjectURL(result.response);
            link = document.createElement('a');
            link.href = url;
            link.download = result.fileName || 'document.pdf';
            link.target = '_blank';
            link.click();
            $timeout(function() {
                URL.revokeObjectURL(url);
            }, 1000);
        }

        function unusedPreviewBillingNoticeTemplateLegacy() {
            var variables = buildClientPortalPreviewVariables();
            var bodyContent = processTemplate(vm.agenceTemplate.billingNoticeTemplate, variables);
            var preambule = escapeHtml(vm.agenceTemplate.preambuleOrdreRecouvrement || '').replace(/\n/g, '<br/>');
            var conclusion = escapeHtml(vm.agenceTemplate.conclusionOrdreRecouvrement || '').replace(/\n/g, '<br/>');

            openPrintablePreview(
                'Aperçu ordre de recouvrement',
                '<div class="document-preview document-preview--a4">'
                    + '<div class="document-preview__brand">' + escapeHtml(vm.agence.nom || 'Aperçu zone') + '</div>'
                    + (preambule ? '<div class="document-preview__section">' + preambule + '</div>' : '')
                    + '<div class="document-preview__section document-preview__section--main">' + (bodyContent || '<em>Aucun modèle configuré.</em>') + '</div>'
                    + (conclusion ? '<div class="document-preview__section">' + conclusion + '</div>' : '')
                    + '</div>'
            );
        }

        function failDocumentPreview(response, previewWindow, isCurrent) {
            previewWindow.close();
            if (!isCurrent || isCurrent()) {
                vm.templateHtmlError = $translate.instant(response && response.data
                    && response.data.message === 'error.unsafeTemplateHtml'
                    ? 'error.unsafeTemplateHtml' : 'error.templateHtmlValidationUnavailable');
            }
        }

        function openPrintablePreview(title, bodyHtml, previewWindow, isCurrent) {
            var newWindow = previewWindow || $window.open('', '_blank');
            if (!newWindow) {
                return;
            }
            // Toujours insérer la sortie OWASP, même lorsque le modèle était déjà en base.
            AgenceTemplate.validateHtml({html: bodyHtml}, function(result) {
                if ((isCurrent && !isCurrent()) || newWindow.closed) {
                    newWindow.close();
                    return;
                }
                newWindow.document.open();
                newWindow.document.write(
                    '<html><head><title>' + escapeHtml(title) + '</title>'
                    + '<style>'
                    + 'body{margin:0;padding:24px;background:#eef3f8;font-family:Georgia,serif;color:#1f2f3d;}'
                    + '.document-preview{margin:0 auto;background:#fff;box-shadow:0 24px 48px rgba(28,44,63,.16);}'
                    + '.document-preview--a4{width:794px;min-height:1123px;padding:56px 64px;}'
                    + '.document-preview--ticket{width:320px;padding:24px 20px;font-size:16px;line-height:1.45;}'
                    + '.document-preview__meta{display:flex;justify-content:space-between;gap:16px;margin-bottom:24px;padding:18px;border:1px solid #d9e2ec;border-radius:12px;background:#f8fbfe;}'
                    + '.document-preview__brand{margin-bottom:24px;font-size:20px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;}'
                    + '.document-preview__section{margin-bottom:24px;font-size:15px;line-height:1.65;}'
                    + '.document-preview__section--main{padding:24px;border:1px solid #d9e2ec;border-radius:18px;background:#fbfdff;}'
                    + '.document-preview__table{width:100%;border-collapse:collapse;font-size:14px;}'
                    + '.document-preview__table th,.document-preview__table td{padding:10px 12px;border:1px solid #d9e2ec;}'
                    + '.document-preview__table thead th{background:#eef5fb;}'
                    + '.document-preview__cell--number{text-align:right;white-space:nowrap;}'
                    + '.document-preview__table-total td{font-weight:700;background:#f7fbff;}'
                    + '.receipt-center{display:block;text-align:center;}.receipt-left{float:left;}.receipt-right{float:right;}'
                    + '.size2{font-size:20px;margin:0;}.size3{font-size:24px;margin:0;}'
                    + '@media print{body{background:#fff;padding:0}.document-preview{box-shadow:none}.document-preview--a4,.document-preview--ticket{width:auto;min-height:auto;padding:18px}}'
                    + '</style></head><body>'
                    + (result.html || '')
                    + '</body></html>'
                );
                newWindow.document.close();
                newWindow.print();
            }, function(response) {
                failDocumentPreview(response, newWindow, isCurrent);
            });
        }

        function buildSampleReceiptPreviewData() {
            return {
                paymentReceipt: {
                    checkId: 'CHK-2026-0042',
                    receiptNumber: 'RCT-2026-0042',
                    machineIdNumber: 'TERM-01',
                    originalPrinted: false
                },
                datePaiement: new Date(),
                paidAmount: 960.00,
                contrat: {
                    referenceContrat: 'CTR-2026-0042',
                    nomPersonne: 'Jean Dupont',
                    adresse: '12 rue de la Paix, 75002 Paris'
                },
                listPaymentReceived: [
                    {
                        serviceName: 'Water sales',
                        paidInclTax: 800.00,
                        paidExclTax: 760.00,
                        taxeName: 'VAT',
                        taxPaid: 40.00,
                        remainingBalanceAfterPayment: 0.00,
                        amountToBePaid: 800.00,
                        remainingBalanceBeforePayment: 800.00
                    },
                    {
                        serviceName: 'Installment',
                        paidInclTax: 160.00,
                        paidExclTax: 160.00,
                        taxeName: '',
                        taxPaid: 0.00,
                        remainingBalanceAfterPayment: 0.00,
                        amountToBePaid: 160.00,
                        remainingBalanceBeforePayment: 160.00
                    }
                ]
            };
        }

        function buildSampleInvoicePreviewData() {
            return {
                invoiceNumber: 'FAC-2026-0042',
                billingDate: new Date(),
                dueDate: new Date(new Date().getTime() + (10 * 24 * 60 * 60 * 1000)),
                customerName: 'Jean Dupont',
                customerAddress: '12 rue de la Paix, 75002 Paris',
                currency: vm.agence.devise || 'EUR',
                lines: [
                    { label: 'Abonnement eau', quantity: 1, unitPrice: 18.00 },
                    { label: 'Consommation 0 - 20 m3', quantity: 20, unitPrice: 1.75 },
                    { label: 'Frais d’entretien compteur', quantity: 1, unitPrice: 6.50 }
                ],
                discountLabel: 'Remise fidélité',
                discountAmount: 5.00,
                taxes: [
                    { label: 'TVA 18%', amount: 11.79 },
                    { label: 'Taxe communale', amount: 2.20 }
                ]
            };
        }

        function renderReceiptTemplate(textData, receiptData) {
            var result = '';
            // Les commandes produisent seules des balises ; le texte libre est toujours échappé.
            var remainingText = escapeHtml(textData || '');
            var commandState = {
                blockOpen: false,
                sizeOpen: false
            };

            remainingText = remainingText.replace(/\n/g, '<br/>').replace(/\s\s/g, ' &nbsp;');
            while (remainingText.length > 0) {
                var commandIndex = remainingText.indexOf('${');
                if (commandIndex < 0) {
                    result += remainingText;
                    remainingText = '';
                } else {
                    if (commandIndex > 0) {
                        result += remainingText.substring(0, commandIndex);
                        remainingText = remainingText.substring(commandIndex);
                    }
                    var endCommandIndex = remainingText.indexOf('}');
                    if (endCommandIndex < 0) {
                        result += remainingText;
                        remainingText = '';
                    } else {
                        var command = remainingText.substring(2, endCommandIndex);
                        result += executeReceiptCommand(command, receiptData, commandState);
                        remainingText = remainingText.substring(endCommandIndex + 1);
                    }
                }
            }

            if (commandState.blockOpen) {
                result += '</span>';
            }
            if (commandState.sizeOpen) {
                result += '</pre>';
            }
            return result || '<em>Aucun modèle configuré.</em>';
        }

        function renderInvoicePreview(invoiceData) {
            var subtotal = 0;
            var totalTaxes = 0;
            var total;
            var i;
            var lineTotal;
            var linesHtml = '';
            var taxesHtml = '';
            var invoiceHeader = escapeHtml(vm.agenceTemplate.enteteFacture || '').replace(/\n/g, '<br/>');

            for (i = 0; i < invoiceData.lines.length; i++) {
                lineTotal = invoiceData.lines[i].quantity * invoiceData.lines[i].unitPrice;
                subtotal += lineTotal;
                linesHtml += '<tr>'
                    + '<td>' + escapeHtml(invoiceData.lines[i].label) + '</td>'
                    + '<td class="document-preview__cell--number">' + formatNumber(invoiceData.lines[i].quantity) + '</td>'
                    + '<td class="document-preview__cell--number">' + formatMoney(invoiceData.lines[i].unitPrice, invoiceData.currency) + '</td>'
                    + '<td class="document-preview__cell--number">' + formatMoney(lineTotal, invoiceData.currency) + '</td>'
                    + '</tr>';
            }

            for (i = 0; i < invoiceData.taxes.length; i++) {
                totalTaxes += invoiceData.taxes[i].amount;
                taxesHtml += '<tr>'
                    + '<td colspan="3">' + escapeHtml(invoiceData.taxes[i].label) + '</td>'
                    + '<td class="document-preview__cell--number">' + formatMoney(invoiceData.taxes[i].amount, invoiceData.currency) + '</td>'
                    + '</tr>';
            }

            total = subtotal - invoiceData.discountAmount + totalTaxes;

            return '<div class="document-preview document-preview--a4 document-preview--invoice">'
                + '<div class="document-preview__brand">' + escapeHtml(vm.agence.nom || 'Zone') + '</div>'
                + (invoiceHeader ? '<div class="document-preview__section">' + invoiceHeader + '</div>' : '')
                + '<div class="document-preview__meta">'
                + '<div><strong>Facture</strong><br/>' + escapeHtml(invoiceData.invoiceNumber) + '</div>'
                + '<div><strong>Date</strong><br/>' + new Date(invoiceData.billingDate).toLocaleDateString() + '</div>'
                + '<div><strong>Échéance</strong><br/>' + new Date(invoiceData.dueDate).toLocaleDateString() + '</div>'
                + '</div>'
                + '<div class="document-preview__section">'
                + '<strong>Client</strong><br/>'
                + escapeHtml(invoiceData.customerName) + '<br/>'
                + escapeHtml(invoiceData.customerAddress)
                + '</div>'
                + '<table class="document-preview__table">'
                + '<thead><tr><th>Désignation</th><th>Qté</th><th>PU</th><th>Montant</th></tr></thead>'
                + '<tbody>' + linesHtml + '</tbody>'
                + '<tfoot>'
                + '<tr><td colspan="3">Sous-total</td><td class="document-preview__cell--number">' + formatMoney(subtotal, invoiceData.currency) + '</td></tr>'
                + '<tr><td colspan="3">' + escapeHtml(invoiceData.discountLabel) + '</td><td class="document-preview__cell--number">-' + formatMoney(invoiceData.discountAmount, invoiceData.currency) + '</td></tr>'
                + taxesHtml
                + '<tr class="document-preview__table-total"><td colspan="3">Total à payer</td><td class="document-preview__cell--number">' + formatMoney(total, invoiceData.currency) + '</td></tr>'
                + '</tfoot>'
                + '</table>'
                + '</div>';
        }

        function executeReceiptCommand(command, receiptData, commandState) {
            var result = '';
            var i;
            var map;
            var key;
            var total;
            if (!command) {
                return result;
            }

            switch (command) {
            case 'center':
                if (commandState.blockOpen) {
                    result += '</span>';
                }
                commandState.blockOpen = true;
                return result + '<span class="receipt-center">';
            case 'left':
                if (commandState.blockOpen) {
                    result += '</span>';
                }
                commandState.blockOpen = false;
                return result;
            case 'right':
                if (commandState.blockOpen) {
                    result += '</span>';
                }
                commandState.blockOpen = true;
                return result + '<span class="receipt-right">';
            case 's1':
                if (commandState.sizeOpen) {
                    result += '</pre>';
                }
                commandState.sizeOpen = false;
                return result;
            case 's2':
                if (commandState.sizeOpen) {
                    result += '</pre>';
                }
                commandState.sizeOpen = true;
                return result + '<pre class="size2">';
            case 's3':
                if (commandState.sizeOpen) {
                    result += '</pre>';
                }
                commandState.sizeOpen = true;
                return result + '<pre class="size3">';
            case 'checkId':
                return escapeHtml(receiptData.paymentReceipt.checkId);
            case 'receiptId':
                return escapeHtml(receiptData.paymentReceipt.receiptNumber);
            case 'dateReceipt':
                return new Date(receiptData.datePaiement).toLocaleDateString() + ' - ' + new Date(receiptData.datePaiement).toLocaleTimeString();
            case 'paid':
                return formatNumber(receiptData.paidAmount);
            case 'paidExclTax':
                total = 0;
                for (i = 0; i < receiptData.listPaymentReceived.length; i++) {
                    total += receiptData.listPaymentReceived[i].paidExclTax;
                }
                return formatNumber(total);
            case 'customerCopy':
                return 'Customer copy';
            case 'servicesPaid':
                return buildReceiptLineHtml(receiptData.listPaymentReceived, 'paidInclTax');
            case 'servicesPaidExclTaxes':
                return buildReceiptLineHtml(receiptData.listPaymentReceived, 'paidExclTax');
            case 'taxesPaid':
                map = {};
                for (i = 0; i < receiptData.listPaymentReceived.length; i++) {
                    if (receiptData.listPaymentReceived[i].taxeName) {
                        map[receiptData.listPaymentReceived[i].taxeName] = (map[receiptData.listPaymentReceived[i].taxeName] || 0) + receiptData.listPaymentReceived[i].taxPaid;
                    }
                }
                result = '';
                for (key in map) {
                    if (map.hasOwnProperty(key)) {
                        result += '<span class="receipt-left">' + escapeHtml(key) + '</span><span class="receipt-right">' + formatNumber(map[key]) + '</span><br/>';
                    }
                }
                return result;
            case 'remainingBalance':
                total = 0;
                for (i = 0; i < receiptData.listPaymentReceived.length; i++) {
                    total += receiptData.listPaymentReceived[i].remainingBalanceAfterPayment;
                }
                return formatNumber(total);
            case 'amountBilled':
                total = 0;
                for (i = 0; i < receiptData.listPaymentReceived.length; i++) {
                    total += receiptData.listPaymentReceived[i].amountToBePaid;
                }
                return formatNumber(total);
            case 'totalToBePaid':
                total = 0;
                for (i = 0; i < receiptData.listPaymentReceived.length; i++) {
                    total += receiptData.listPaymentReceived[i].amountToBePaid - receiptData.listPaymentReceived[i].remainingBalanceBeforePayment;
                }
                return formatNumber(total);
            case 'balanceBeforePayment':
                total = 0;
                for (i = 0; i < receiptData.listPaymentReceived.length; i++) {
                    total += receiptData.listPaymentReceived[i].remainingBalanceBeforePayment;
                }
                return formatNumber(total);
            case 'servicesToBePaid':
                return buildReceiptLineHtml(receiptData.listPaymentReceived, 'amountToBePaid');
            case 'taxesToBePaid':
                map = {};
                for (i = 0; i < receiptData.listPaymentReceived.length; i++) {
                    if (receiptData.listPaymentReceived[i].taxeName) {
                        map[receiptData.listPaymentReceived[i].taxeName] = (map[receiptData.listPaymentReceived[i].taxeName] || 0) + receiptData.listPaymentReceived[i].taxPaid;
                    }
                }
                result = '';
                for (key in map) {
                    if (map.hasOwnProperty(key)) {
                        result += '<span class="receipt-left">' + escapeHtml(key) + '</span><span class="receipt-right">' + formatNumber(map[key]) + '</span><br/>';
                    }
                }
                return result;
            case 'machineIdNumber':
                return escapeHtml(receiptData.paymentReceipt.machineIdNumber);
            case 'contractRef':
                return escapeHtml(receiptData.contrat.referenceContrat);
            case 'contractName':
                return escapeHtml(receiptData.contrat.nomPersonne);
            case 'contractAddress':
                return escapeHtml(receiptData.contrat.adresse);
            default:
                return result;
            }
        }

        function buildReceiptLineHtml(lines, amountField) {
            var result = '';
            var i;
            for (i = 0; i < lines.length; i++) {
                result += '<span class="receipt-left">' + escapeHtml(lines[i].serviceName) + '</span>'
                    + '<span class="receipt-right">' + formatNumber(lines[i][amountField]) + '</span><br/>';
            }
            return result;
        }

        function formatNumber(value) {
            return Number(value || 0).toFixed(2);
        }

        function formatMoney(value, currency) {
            return formatNumber(value) + ' ' + (currency || '');
        }

        function escapeHtml(value) {
            return (value || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        }

        function hashString(value) {
            var stringValue = value || '';
            var hash = 0;
            var i;
            var chr;
            for (i = 0; i < stringValue.length; i++) {
                chr = stringValue.charCodeAt(i);
                hash = ((hash << 5) - hash) + chr;
                hash |= 0;
            }
            return hash;
        }

        function buildEmptyAgenceTemplate() {
            return {
                enteteFacture: null,
                preambuleOrdreRecouvrement: null,
                conclusionOrdreRecouvrement: null,
                receiptTemplate: null,
                billingNoticeTemplate: null,
                communicationGlobalSmsTemplate: null,
                communicationGlobalEmailTemplateHtml: null
            };
        }

        function buildAgenceTemplatePreviewPayload() {
            var payload = angular.copy(vm.agence || {});

            payload.enteteFacture = vm.agenceTemplate.enteteFacture;
            payload.preambuleOrdreRecouvrement = vm.agenceTemplate.preambuleOrdreRecouvrement;
            payload.conclusionOrdreRecouvrement = vm.agenceTemplate.conclusionOrdreRecouvrement;
            payload.receiptTemplate = vm.agenceTemplate.receiptTemplate;
            payload.billingNoticeTemplate = vm.agenceTemplate.billingNoticeTemplate;

            return payload;
        }
        

    }
})();
